import { Card } from 'antd'
import type { CSSProperties, ReactNode } from 'react'
import styles from './index.module.css'

type SettingsCardProps = {
  children: ReactNode
  style?: CSSProperties
}

/**
 * Provides a shared visual boundary for settings in the notification drawer.
 */
function SettingsCard({ children, style }: SettingsCardProps) {
  return (
    <Card bordered={false} className={styles.card} style={style}>
      {children}
    </Card>
  )
}

export default SettingsCard
